import { render, staticRenderFns } from "./BonEntreDetail.vue?vue&type=template&id=e7065ee6&"
import script from "./BonEntreDetail.vue?vue&type=script&lang=js&"
export * from "./BonEntreDetail.vue?vue&type=script&lang=js&"
import style0 from "./BonEntreDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports